import { parseISO } from 'date-fns/parseISO'

export const EPOCH = parseISO('1970-01-01')

export const DATEFORMAT_FULL = 'MMMM d, yyyy'
export const DATEFORMAT_SHORT = 'M/d/yy'
export const DATEFORMAT_SYSTEM = 'yyyy-MM-dd'
